import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { DateInputComponent } from 'components/input/date-input/date-input.component';
import { InputType } from 'enums/InputType';
import { CustomPropertyType, QueryPropertyModel, QueryPropertyType, QueryPropertyValueType } from 'models/generated/Models.QueryProperty';
import { SelectListItemModel } from 'models/SelectList';
import { TranslatePipe } from 'pipes/translate.pipe';
import { TaskflowTemplateService } from 'services/taskflow-template.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'query-input',
	templateUrl: './query-input.component.html',
	imports: [CustomInputComponent, DateInputComponent, CustomSelectComponent, TranslatePipe]
})
export class QueryInputComponent {

	@Output() valueChange = new EventEmitter<any>();

	inputTypeEnum = InputType;
	queryPropertyType = QueryPropertyType;
	queryPropertyValueType = QueryPropertyValueType;
	queryCustomType = CustomPropertyType;

	selectList: SelectListItemModel[] = [];
	usersList: SelectListItemModel[] = [];
	taskTemplateTagList: SelectListItemModel[] = [];
	taskflowTemplateTagList: SelectListItemModel[] = [];
	userTeamList: SelectListItemModel[] = [];

	_propertyName = '';

	@Input() value: any;

	@Input()
	set options(options: { [key: string]: string }) {
		this.selectList = [];
		for (let key in options) {
			if (options.hasOwnProperty(key) && key != '$id') {
				this.selectList.push(new SelectListItemModel(key, options[key]));
			}
		}
	}

	private _queryProperties: QueryPropertyModel[] =[];
	@Input()
	set queryProperties(queryProperties: QueryPropertyModel[]) {
		this._queryProperties = queryProperties;
		this.loadQueryProperty();
	}
	get queryProperties() {
		return this._queryProperties;
	}
	@Input() queryProperty?: QueryPropertyModel;

	@Input()
	set propertyName(name: string) {
		this._propertyName = name;
		this.loadQueryProperty();
	}
	get propertyName() {
		return this._propertyName;
	}

	constructor(private userService: UserService, readonly taskflowTemplateService: TaskflowTemplateService) {
	}
	
	updateValue(value: any) {
		this.value = value;
		this.valueChange.emit(value);
	}

	loadQueryProperty() {
		if (!this.propertyName || !this.queryProperties) return;

		this.queryProperty = this.queryProperties!.find(queryProperty => queryProperty.name.toLowerCase() == this.propertyName.toLowerCase());

		this.usersList = [];
		this.taskTemplateTagList = [];
		this.taskflowTemplateTagList = [];
		this.userTeamList = [];

		if (!this.queryProperty) return;
		
		switch (this.queryProperty.type) {
			case QueryPropertyType.InputTeamId:
				this.userService.activeTeams.forEach(team => {
					this.userTeamList.push(new SelectListItemModel(team.id!, team.name));
				});
				break;
		}

		switch (this.queryProperty.customProperty) {
			case CustomPropertyType.TaskTemplateTag:
				this.taskflowTemplateService.getAllTaskTemplateTags().then(taskTemplateTags => {
					for (let taskTemplateTag of taskTemplateTags) {
						this.taskTemplateTagList.push(new SelectListItemModel(taskTemplateTag.tag,
							taskTemplateTag.tag));
					}
				});
				break;
			case CustomPropertyType.TaskflowTemplateTag:
				this.taskflowTemplateService.getAllTaskflowTemplateTags().then(taskflowTemplateTags => {
					for (let taskflowTemplateTag of taskflowTemplateTags) {
						this.taskflowTemplateTagList.push(new SelectListItemModel(taskflowTemplateTag.tag,
							taskflowTemplateTag.tag));
					}
				});
				break;
		}

		this.usersList = this.userService.getUserSelectList();
	}

}
